export default "__VITE_ASSET__Y4KfS1yE__"